import { configureStore } from '@reduxjs/toolkit';
import { api } from './services';

// Slices
import sessionReducer from './slices/sessionSlice';
import titleReducer from './slices/titleSlice';

const store = configureStore({
    reducer: {
        [api.reducerPath]: api.reducer,
        session: sessionReducer,
        title: titleReducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware)
});

export default store;
